var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.002,
    viewBox: "0 0 20.001 20.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.634)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.907 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.5,373.893a.491.491,0,0,1-.348-.144l-2.689-2.689a.492.492,0,0,1,0-.7l13.788-13.788a.492.492,0,1,1,.7.7l-13.44,13.44,1.994,1.994,13.44-13.439a.492.492,0,0,1,.7.7l-13.788,13.787A.49.49,0,0,1,598.5,373.893Z",
    transform: "translate(-595.315 -356.432)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 13.788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.993,404.062a.492.492,0,0,1-.454-.68l1.907-4.6a.492.492,0,1,1,.909.377l-1.451,3.5,3.5-1.451a.492.492,0,0,1,.377.909l-4.6,1.907A.492.492,0,0,1,589.993,404.062Z",
    transform: "translate(-589.501 -398.482)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M640.781,358.728a.492.492,0,0,1-.348-.84,1.41,1.41,0,1,0-1.993-1.994.492.492,0,0,1-.7-.7,2.393,2.393,0,1,1,3.385,3.385A.49.49,0,0,1,640.781,358.728Z",
    transform: "translate(-637.6 -354.498)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.427 1.902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636.681,363.973a.49.49,0,0,1-.348-.144l-2.69-2.69a.492.492,0,0,1,.7-.7l2.69,2.69a.492.492,0,0,1-.348.84Z",
    transform: "translate(-633.499 -360.299)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ec625a55f6bc9f2fb3b15e18c8a05d87.svg";
export { ForwardRef as ReactComponent };